<template>
    <div>
        <el-dialog
            v-model="modalState.visible"
            :title="modalState.title"
            :width="isMobile ? '90%' : '80%'"
            destroy-on-close
            :append-to-body="true"
            center
            >
            <el-form ref="formRef" :model="modalState.item.assorts" scroll-to-error>
                <ul v-if="modalState?.item?.assorts" class="list-group list-group-flush">
                    <li
                        v-for="(assort, index) in modalState?.item?.assorts"
                        :key="assort.id"
                        class="list-group-item"
                        >
                        <div class="d-flex flex-column flex-md-row w-100 justify-content-md-between align-items-center">
                            <div>
                                <div class="mb-1 h6">{{ dt(assort.name_translations) }}</div>
                                <div>
                                    <span v-if="!hiddenPrice">
                                        <small class="mr-2" style="text-decoration: line-through">
                                            {{ aliasTranslations?.comm_price || $t("carts.commPrice") }}
                                            
                                            {{ assort.symbol }}
                                            {{ currencyFormat(assort.comm_price) }}
                                        </small>
                                        <span v-if="promotion?.id" class="text-primary">
                                            {{ aliasTranslations?.sale_price || '活動價' }}
                                            
                                            {{ assort.symbol }}
                                            {{ currencyFormat(assort.discounted_price) }}
                                        </span>
                                        <small v-if="promotion?.id && assort.comm_price - assort.discounted_price > 0">
                                            (揪團省
                                            {{ assort.symbol }}
                                            {{ currencyFormat(assort.comm_price - assort.discounted_price) }})
                                        </small>
                                        <span v-if="!promotion?.id" class="text-primary">
                                            {{ assort.symbol }}
                                            {{ currencyFormat(assort.sale_price) }}
                                        </span>
                                    </span>

                                    <span v-if="promotion?.display_coin_reward && assort.owner_coin_reward > 0" class="h4 text-warning d-inline-flex">
                                        <img src="/static/images/coin.png" style="max-height: 30px" alt="owner_coin_reward">
                                        {{ currencyFormat(assort.owner_coin_reward) }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="assort.buy_qty && !hiddenPrice" class="mx-3" style="color: #3b71de;">
                                {{ assort.symbol }} 
                                <span v-if="promotion?.id">
                                    {{ currencyFormat(assort.discounted_price * assort.buy_qty) }}
                                </span>
                                <span v-else>
                                    {{ currencyFormat(assort.sale_price * assort.buy_qty) }}
                                </span>
                            </div>
                            
                            <div v-if="!hiddenCart" style="width: 160px">
                                <el-form-item
                                    :prop="index + '.buy_qty'"
                                    :rules="[
                                        {
                                            type: 'number',
                                            min: !!assort.buy_qty ? assort.min_order_quantity : 0,
                                            max: maxOrderQuantity(assort),
                                            message: `請輸入 ${assort.min_order_quantity} ~ ${maxOrderQuantity(assort)} 之間`, trigger: 'blur'
                                        },
                                    ]"
                                >
                                    <span v-if="!assort.unlimited_inventory && assort.inventory<=0" class="text-primary h4">已售完</span>
                                    <product-quantity
                                        v-else
                                        v-model="modalState.item.assorts[index].buy_qty"
                                        :min="assort.min_order_quantity"
                                        :max="maxOrderQuantity(assort)"
                                        :disabled="loading"
                                    />
                                    <template #error="{ error}">
                                        <div class="w-100 text-danger text-center">{{ error }}</div>
                                    </template>
                                </el-form-item>
                            </div>
                        </div>
                    </li>
                </ul>
            </el-form>
            <template #footer>
                <div v-if="cartTotal" class="px-3 mb-3 alert alert-secondary">
                    <div v-if="!hiddenPrice" class="row">
                        <div v-if="assortDiscountTotal > 0" class="d-inline pr-3">
                            商品折扣：<span class="text-primary">-{{assortSymbol}} {{currencyFormat(assortDiscountTotal)}}</span>
                        </div>
                        <div v-if="promDiscountTotal > 0" class="d-inline pr-3">
                            活動折扣：<span class="text-primary">-{{assortSymbol}} {{currencyFormat(promDiscountTotal)}}</span>
                        </div>
                    </div>

                    <div class="row">
                        <div v-if="!hiddenPrice" class="d-inline pr-3">
                            {{ t('carts.subTotal') }}:
                            <span class="text-primary">{{assortSymbol}} {{ currencyFormat(cartTotal) }}</span>
                        </div>
                        <div class="d-inline pr-3">
                            總件數：<span class="text-primary">{{currencyFormat(cartCount)}}</span>
                        </div>
                    </div>
                </div>

                <!-- <button class="btn btn-outline-dark mr-2" type="button" :disabled="loading" @click="handleCloseItem">
                    {{ t("global.cancel") }}
                </button> -->

                <button v-if="!hiddenCart" class="btn btn-secondary" type="button" :disabled="loading || !cartCount" @click="addToCart">
                    {{ aliasTranslations?.add_to_cart || t("carts.addToCart") }}
                </button>

                <button v-if="!hiddenCart" class="btn btn-primary ml-2" type="button" :disabled="loading || !cartCount" @click="buyNow">
                    {{ aliasTranslations?.buy_now || t("carts.buyNow") }}
                </button>

            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel } from '@vueuse/core'
import { lookupAliasTranslations, dataTranslations as dt, breakpoint, currencyFormat, checkBuyQty, imgProxy } from "../../utils"
import ProductQuantity from "./ProductQuantity.vue"

const props = defineProps({
    data: { type: Object, required: true },
    storeData: { type: Object, required: true },
    promotion: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
})
const emit = defineEmits(['update:modelValue', 'add-to-cart', 'buy-now'])

const { t, n, locale } = useI18n()

const modalState = useVModel(props, 'data', emit)
const isMobile = computed(() => breakpoint.value.xs)
const hiddenPrice = computed(() => !!props.storeData?.settings?.hidden_price)
const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)
const hiddenContact = computed(() => !!props.storeData?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(props.storeData?.alias_translations, locale.value))

const assortOrgTotal = computed(() => modalState.value.item.assorts.reduce((total, assort) => (total += assort.comm_price * assort.buy_qty), 0))
const assortTotal = computed(() => modalState.value.item.assorts.reduce((total, assort) => (total += assort.discounted_price * assort.buy_qty), 0))
const assortDiscountTotal = computed(() => assortOrgTotal.value - assortTotal.value)
const assortSymbol = computed(() => modalState.value.item.assorts.length ? modalState.value.item.assorts[0].symbol : "")
const cartCount = computed(() => modalState.value.item.assorts.reduce((total, assort) => (total += assort.buy_qty), 0))
const cartTotal = computed(() => assortTotal.value - promDiscountTotal.value)
const promDiscountTotal = computed(() => {
    let discount_type = props.promotion?.discount_type;
    let discount_value = null;

    // 滿額
    if (props.promotion?.condition_min_type == 'amount') {
        props.promotion.conditions.forEach((condition) => {
            if (assortTotal.value >= condition.min_amount) {
                if (discount_type == 'amount') {
                    discount_value = condition.discount_amount
                } else if (discount_type == 'percentage') {
                    discount_value = condition.discount_percentage
                }
            }
        })
    }
    // 滿件
    else if (props.promotion?.condition_min_type == 'qty') {
        props.promotion.conditions.forEach((condition) => {
            if (cartCount.value >= condition.min_qty) {
                if (discount_type == 'amount') {
                    discount_value = condition.discount_amount
                } else if (discount_type == 'percentage') {
                    discount_value = condition.discount_percentage
                }
            }
        })
    }

    if (discount_type && discount_value) {
        if (discount_type == 'amount') {
            return discount_value
        } else if (discount_type == 'percentage') {
            return assortTotal.value * (discount_value/100)
        }
    }
    return 0
})

const formRef = ref()

const chkBuyQty = () => {
    const items = checkBuyQty(modalState.value.item.assorts)
    if (!items.length) {
      swal.fire({
          title: '請選擇數量',
          type: 'error',
      })
      return []
    }
    return items
}

const addToCart = () => {
    const items = chkBuyQty()
    if (!formRef.value) return
    
    formRef.value.validate((valid) => {
        if (valid && items.length) {
            emit("add-to-cart", items)
        }
    })
}
const buyNow = () => {
    const items = chkBuyQty()
    if (!formRef.value) return
    
    formRef.value.validate((valid) => {
        if (valid && items.length) {
            emit("buy-now", items)
        }
    })
}
const maxOrderQuantity = (assort) => {
    const quantity = assort?.max_order_quantity || 20
    if (assort.unlimited_inventory) {
        // 無限庫存
        return quantity
    }
    if (assort?.max_order_quantity > assort?.inventory) {
        return assort?.inventory
    }
    return quantity
}
</script>
